<template lang="pug">
  .seasonal-container
    section.section-1
      .container
        .search-wrap
          .find-btn-wrap
            router-link.main-btn.col-white.bg-red(v-if="!query" :to="{name: 'FindCategories', params: {lang: getLanguage}, query: {search: 'workers', seasonal: true}}")
              img(src="/webapp/images/home/employer-search.png")
              span {{ gettext('Find seasonal workers') }}
                .mdi.mdi-chevron-right
            router-link.main-btn.col-white.bg-red(v-else :to="{name: 'Workers', params: {lang: getLanguage}, query: {q: query}}")
              img(src="/webapp/images/home/employer-search.png")
              span {{ gettext('Find seasonal workers') }}
                .mdi.mdi-chevron-right
            router-link.main-btn.col-white.bg-black(:to="{name: 'FindJob', params: {lang: getLanguage}, query: computedQuery}")
              img(src="/webapp/images/home/job-seaker-search.png")
              span {{ gettext('Find seasonal jobs') }}
                .mdi.mdi-chevron-right
    section.section-2
      .block-wrap
        .block
          .video(@click="showVideoModal=!showVideoModal")
            img(src="/webapp/img/how-bixter-works.13fcc64.jpg")
            .play
              i.mdi.mdi-triangle
        .block
          .text
            h3 {{ gettext('Connecting Employers and Job Seekers on Easy-to-use Platform') }}
            p {{ gettext('Looking for seasonal job? Or maybe seasonal employee? Bixter.work is unique platform that helps companies and employees around the world find each other without contributions and intermediaries.') }}
    section.section-3.gray-bg
      .block-wrap
        .block
          .title-img
            img(src="/webapp/images/home/Bixter-Employer.png")
        .block
          .description-text
            .headline {{ gettext('employers') }}
            h3 {{ gettext('Too busy for searching the right candidate for your seasonal position by your criteria?') }}
            .head {{ gettext('Check the benefits you get from Bixter') + ':' }}
            ul
              li {{ gettext('Pick the right candidate') }}
              li {{ gettext('Verifying their language skills') }}
              li {{ gettext('The cheapest solution') }}
              li {{ gettext('Guarantee: If you are not satisfied we will find you another match with no charge') }}
            .btn-wrap
              router-link.btn(:to="{name: 'Contacts'}") {{ gettext('Contact Us') }}
              router-link.btn.trasparent(:to="{name: 'PersonalMatch'}") {{ gettext('Check prices') }}
    section.section-3.right-img
      .block-wrap
        .block
          .description-text.black
            .headline {{ gettext('job seekers') }}
            h3 {{ gettext('Looking to find a good paying seasonal job in your industry?') }}
            .head {{ gettext('Here is how Bixter can help you out') + ':' }}
            ul
              li {{ gettext('Large database of seasonal jobs') }}
              li {{ gettext('Good paying seasonal jobs') }}
              li {{ gettext('Good opportunities in different countries') }}
              li {{ gettext('User friendly platform') }}
              li {{ gettext('All contracts are free of charge') + '*' }}
            .btn-wrap
              router-link.btn(:to="{name: 'FindJob'}") {{ gettext('Find Work') }}
            .extra *{{ gettext('Extra fee is charged for non-EU job-seekers for work permit application procedure.') }}
        .block
          .title-img
            img(src="/webapp/images/home/Bixter-Employee.png")
      section.section-6.gray-bg
        .block-wrap
          .section-6-wrap
            .headline
              span {{ ' ' + gettext('seasonal workplaces') + ' ' }}
              span {{ gettext('in different countries all over the world') }}
            .countries
              router-link.country(:to="`/${getLanguage}/countries/country/denmark`")
                .img(style="background-image: url(/webapp/images/countries/denmark.png);")
                .filter
                span {{ gettext('Denmark') }}
              router-link.country(:to="`/${getLanguage}/countries/country/germany`")
                .img(style="background-image: url(/webapp/images/countries/germany.png);")
                .filter
                span {{ gettext('Germany') }}
              router-link.country(:to="`/${getLanguage}/countries/country/norway`")
                .img(style="background-image: url(/webapp/images/countries/1.png);")
                .filter
                span {{ gettext('Norway') }}
              router-link.country(:to="`/${getLanguage}/countries/country/estonia`")
                .img(style="background-image: url(/webapp/images/countries/estonia-min.png);")
                .filter
                span {{ gettext('Estonia') }}
            router-link.btn(:to="`/${getLanguage}/countries`") {{ gettext('More countries') }}
            .headline
              span.red {{ ' ' + gettext('seasonal workers') + ' ' }}
              span {{ gettext('from different countries') }}
            .countries
              router-link.country(:to="`/${getLanguage}/countries/country/ukraine`")
                .img(style="background-image: url(/webapp/images/countries/Ukraine.jpg);")
                .filter
                span {{ gettext('Ukraine') }}
              router-link.country(:to="`/${getLanguage}/countries/country/belarus`")
                .img(style="background-image: url(/webapp/images/countries/belarus.jpg);")
                .filter
                span {{ gettext('Belarus') }}
              router-link.country(:to="`/${getLanguage}/countries/country/kazakhstan`")
                .img(style="background-image: url(/webapp/images/countries/kazakhstan.jpg);")
                .filter
                span {{ gettext('Kazakhstan') }}
              router-link.country(:to="`/${getLanguage}/countries/country/kyrgyzstan`")
                .img(style="background-image: url(/webapp/images/countries/kyrgyzstan.jpg);")
                .filter
                span {{ gettext('Kyrgyzstan') }}
            router-link.btn(:to="`/${getLanguage}/countries`") {{ gettext('More countries') }}
    section.section-5
      .block-wrap
        .section-5-wrap
          h3 {{ gettext('Are you still not with us?') }}
          router-link.main-btn.col-white.bg-red(:to="`/${getLanguage}/registration`" v-if="!$auth.check()") {{ gettext('Create an account') }}
          router-link.main-btn.col-white.bg-red(
            :to="{name: 'CreateCV', params: {lang: getLanguage}, query: {type: 'seasonal'}}"
            v-if="$auth.check() && ~[CONSTANTS.JOBSEEKER_PROFILE_TYPE, CONSTANTS.SENDER_PROFILE_TYPE].indexOf(getUser.profile_type)") {{ gettext('Create CV for seasonal work') }}
          router-link.main-btn.col-white.bg-red(
            :to="{name: 'CreateJob', params: {lang: getLanguage}}"
            v-if="$auth.check() && ~[CONSTANTS.EMPLOYER_PROFILE_TYPE, CONSTANTS.RECEIVER_PROFILE_TYPE].indexOf(getUser.profile_type)") {{ gettext('Create vacancy') }}

    video-modal(
    v-if="showVideoModal"
    @close="showVideoModal = !showVideoModal"
    :isYoutube="false"
    :iframeSrc="link"
    videoType="video/mp4"
    )
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import { gettext } from './../../services/TranslateHandler'
import AjaxDropdown from '@/components/ajax-dropdown'
import AjaxMultiselect from '@/components/ajax-multiselect'
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'
import VideoModal from '@/components/video-modal'
import LocationDropdown from '@/components/location-dropdown'
import mixin from '@/mixins'
import slider from './parts/slider'

const inactive = require('@/constants.json')
const CONSTANTS = require('@/constants.json')
export default {
  name: 'Seasonal',
  metaInfo () {
    return this.getMetaInfoMixin({defaultMetaInfo: this.defaultMetaInfo})
  },
  components: {
    swiper,
    swiperSlide,
    VideoModal,
    LocationDropdown,
    AjaxDropdown,
    AjaxMultiselect,
    slider
  },
  mixins: [
    mixin
  ],
  data () {
    return {
      seasonalType: 0,
      CONSTANTS: CONSTANTS,
      inactive: inactive,
      showVideoModal: false,
      employer: true,
      country: '',
      query: '',
      swiperOption: {
        slidesPerView: 5,
        loop: true,
        loopFillGroupWithBlank: true,
        breakpoints: {
          400: {
            slidesPerView: 1
          },
          550: {
            slidesPerView: 2
          },
          768: {
            slidesPerView: 3
          },
          1024: {
            slidesPerView: 4
          }
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        }
      }
    }
  },
  methods: {
    gettext: gettext,
    ...mapActions([
      'receiveEmploymentTypes'
    ]),
    search () {
      let query = {}
      if (this.query) query.q = this.query
      if (this.country) query.c = this.country
      if (this.employer) this.$router.push({name: 'Workers', params: {lang: this.getLanguage}, query: {...query, se: true}})
      else this.$router.push({name: 'FindJob', params: {lang: this.getLanguage}, query: {...query, emt: this.seasonalType}})
    }
  },
  async created () {
    let types = await this.receiveEmploymentTypes({lang: this.getLanguage})
    this.seasonalType = ((types.find(item => item.is_seasonal)) || {}).id
  },
  computed: {
    ...mapGetters([
      'getLanguage',
      'getUser'
    ]),
    computedQuery () {
      if (this.query || this.country) return {q: this.query, c: this.country, emt: this.seasonalType}
      return {emt: this.seasonalType}
    },
    defaultMetaInfo () {
      return {
        title: 'Bixter | ' + gettext('Seasonal'),
        titleTemplate: null,
        link: [
          {rel: 'canonical', href: document.location.origin + document.location.pathname}
        ]
      }
    },
    link () {
      let lang = this.getLanguage || 'en'
      return this.$store.state.promoVideos[lang].video_url
    }
  }
}
</script>
<style lang="scss" src="./styles.scss"></style>



// WEBPACK FOOTER //
// src/pages/seasonal/index.vue